import { defineComponent as _defineComponent } from 'vue'
import deviceHelper from "@/utils/deviceInfo";
import { ref } from "vue";
import InlineSvg from "vue-inline-svg";


const __default__ = {
  name: "ZoomControl",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  landscape: {
    type: Boolean,
    default: false,
  },
  targetContainerId: {
    type: String,
    default: "center",
  },
  targetContentId: {
    type: String,
    default: "center-content",
  },
},
  emits: ["onUpdatedZoom"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const isiOS = deviceHelper.isiOS();
const isSafari = deviceHelper.isSafari();

// 확대 / 축소 처리
const initialZoom = 1.0;
const currentZoom = ref(initialZoom);
const zoomStep = 0.5;
const minZoom = 1.0;
const maxZoom = 3.0;

const updateZoom = (zoomLevel: number) => {
  const centerContent = document.getElementById(props.targetContentId);
  const center = document.getElementById(props.targetContainerId);
  if (!centerContent || !center) return;

  // 줌 레벨을 min/max 범위 내로 제한
  currentZoom.value = Math.min(maxZoom, Math.max(minZoom, zoomLevel));

  Object.assign(centerContent.style, {
    transform: `scale(${currentZoom.value})`,
    transformOrigin: "0 0",
  });

  const isZoomedIn = currentZoom.value > initialZoom;

  /**
   * iOS와 Safari에서는 scale 값이 변한다고 레이아웃을 재계산하지 않음.
   * 따라서 overflow를 값을 변경하여 레이아웃을 재계산하도록 하기 위함
   */
  if (isSafari || isiOS) {
    center.style.overflow = "visible";
    if (isZoomedIn) {
      setTimeout(() => {
        center.style.overflow = "scroll";
      }, 0);
    } else {
      center.style.removeProperty("overflow"); // 인라인 스타일로 설정한 overflow 제거
    }
  } else {
    if (isZoomedIn) {
      center.style.overflow = "scroll";
    } else {
      center.style.removeProperty("overflow"); // 인라인 스타일로 설정한 overflow 제거
    }
  }

  emit("onUpdatedZoom", isZoomedIn);
};

const resetZoom = () => {
  currentZoom.value = initialZoom;

  const centerContent = document.getElementById(props.targetContentId);
  const center = document.getElementById(props.targetContainerId);
  if (!centerContent || !center) return;

  Object.assign(centerContent.style, {
    transform: `scale(${currentZoom.value})`,
    transformOrigin: "0 0",
  });

  center.style.overflow = "visible";
};

const zoomIn = () => {
  if (currentZoom.value < maxZoom) {
    const zoomLevel = currentZoom.value + zoomStep;
    updateZoom(zoomLevel);
  }
};

const zoomOut = () => {
  if (currentZoom.value > minZoom) {
    const zoomLevel = currentZoom.value - zoomStep;
    updateZoom(zoomLevel);
  }
};

__expose({ resetZoom });

const __returned__ = { props, emit, isiOS, isSafari, initialZoom, currentZoom, zoomStep, minZoom, maxZoom, updateZoom, resetZoom, zoomIn, zoomOut, get InlineSvg() { return InlineSvg } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})